const localesParsed = localesSchema.safeParse(locales);

export function useLocales() {
  if (!localesParsed.success) {
    throw new Error("Invalid locales data");
  }
  return { locales: localesParsed.data };
}
